import { AddonServiceDto } from 'actions/addonServices/AddonServicesDtos';
import { AddonService } from 'types/AddonService';

export const convertToAddonService = (addonService: AddonServiceDto): AddonService => {
    return {
        id: addonService.id,
        name: addonService.name,
        active: addonService.active,
        taxable: addonService.taxable,
        price: parseFloat(addonService.price),
        businessAreas: addonService.business_areas ?? []
    };
};
